// Depoimentos da página inicial.
//
// Coloque em `testimonials` SOMENTE depoimentos reais de clientes (com autorização
// delas). Publicar avaliações inventadas como se fossem de clientes é propaganda
// enganosa (Código de Defesa do Consumidor, art. 37; Conar) e pode gerar multa.
//
// Enquanto `testimonials` estiver vazio, a seção só aparece na visualização local
// (npm run dev), com os textos de exemplo abaixo, pra dar pra avaliar o layout.
// No site publicado ela fica escondida.
export interface Testimonial {
  name: string;
  city: string; // cidade e estado, ex.: "Campinas, SP"
  text: string;
  stars: number;
}

export const testimonials: Testimonial[] = [];

export const sampleTestimonials: Testimonial[] = [
  { name: "Maria Clara S.", city: "Campinas, SP", stars: 5, text: "Chegou rápido e bem embalado. As peças são lindas e de excelente qualidade." },
  { name: "Juliana R.", city: "Belo Horizonte, MG", stars: 5, text: "Amei os brincos! São ainda mais lindos pessoalmente. Entrega no prazo." },
  { name: "Fernanda L.", city: "Fortaleza, CE", stars: 5, text: "Produtos de alta qualidade, com acabamento impecável. Já virei cliente fiel!" },
  { name: "Camila A.", city: "Curitiba, PR", stars: 5, text: "Atendimento excelente e as peças vieram exatamente como nas fotos. Recomendo!" },
  { name: "Beatriz M.", city: "Salvador, BA", stars: 5, text: "Comprei para presentear e minha amiga amou. Embalagem linda e entrega rápida." },
  { name: "Larissa P.", city: "Porto Alegre, RS", stars: 5, text: "Brincos leves, bonitos e que não escurecem. Já fiz o segundo pedido!" },
];

// Mude para true só se você decidir mostrar os textos de exemplo no site publicado
// (não recomendado: veja o aviso acima).
export const SHOW_SAMPLE_TESTIMONIALS = false;
